import React from "react";
import { Helmet } from "react-helmet";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  Pagination,
  Space,
  Popconfirm,
  Modal,
  Spin,
  message,
  Image,
  Radio,
} from "antd";
import cookie from "react-cookies";
import axios from "axios";
import { DeleteFilled, EyeOutlined, EditOutlined } from "@ant-design/icons";
// scroll Top
const useScroll = () => {
  const myRef = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView();
  return [executeScroll, myRef];
};
const Reports = () => {
  // contact data usestate
  const [contactData, setContactData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const [viewData, setViewData] = useState({});
  const [activeCategory, setActiveCategory] = useState("image_report");
  const [executeScroll, myRef] = useScroll();

  const navigate = useNavigate();
  //  date to define
  const date = new Date();
  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // method for API call
  const getContactHandler = (page, activeCategory) => {
    setLoader(true);
    // login token
    const token = cookie.load("token");
    const config = {
      headers: { Authorization: `Bearer ${JSON.parse(token)}` },
    };
    //axios call
    axios
      .get(
        `${process.env.REACT_APP_FRONTED_URL}/contact-us-requests?locale=en&page=${page}&category=${activeCategory}`,
        config
      )
      .then((response) => {
        const filterData = response?.data?.data?.data.filter(
          (item) =>
            item?.category === "image_report" ||
            item?.category === "chat_report"
        );
        setContactData({ ...response?.data?.data, data: filterData });
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  //  API for contact
  useEffect(() => {
    getContactHandler(currentPage, activeCategory);
    executeScroll();
    // eslint-disable-next-line
  }, []);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?.id);

    const token = cookie.load("token");
    const config = {
      headers: { Authorization: `Bearer ${JSON.parse(token)}` },
    };
    // API call to delete selected record
    axios
      .delete(
        `${process.env.REACT_APP_FRONTED_URL}/delete-contact-us-requests?requests_ids[0]=${data?.id}&locale=en`,
        config
      )
      .then(() => {
        // to delete locally from our database
        const remaingRecords = contactData?.data?.filter(
          (item) => item?.id !== data?.id
        );
        setContactData({ ...contactData, data: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  const cancel = (e) => {
    console.log(e);
  };

  const getDateHandler = (date) => {
    const d = new Date(date);
    const day = d.getDate();
    return day;
  };
  // Modal
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // table columns
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      key: "phone",
      dataIndex: "phone",
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (data) => (
        <Space size="middle">
          {getDateHandler(data) +
            "-" +
            month[date?.getMonth(data)] +
            "-" +
            date?.getFullYear(data)}
        </Space>
      ),
    },
    {
      title: "Message",
      key: "message",
      dataIndex: "message",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
    },
    {
      title: "Category",
      key: "category",
      dataIndex: "category",
      render: (data) => (
        <div>
          {data === "chat_report" && "Chat Report"}
          {data === "image_report" && "Image Report"}
        </div>
      ),
    },
    {
      title: "Action",
      key: "",
      render: (data) => (
        <div className="flex">
          <div className="px-4">
            <EyeOutlined
              className="cursor-pointer"
              onClick={() => {
                showModal();
                setViewData(data);
              }}
            />
          </div>
          <div className="px-4">
            <EditOutlined
              className="cursor-pointer"
              onClick={() => {
                navigate(`/edit-contact-status/${data?.id}`);
              }}
            />
          </div>

          <div className="px-4">
            {data?.id === selectedRecord ? (
              <Spin />
            ) : (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => confirm(data)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteFilled className="cursor-pointer" />
              </Popconfirm>
            )}
          </div>
        </div>
      ),
    },
  ];
  return (
    <React.Fragment>
      <Helmet>
        <title>4EVERINLOVE - REPORTS</title>
        <meta name="description" content="4everinlove Reports" />
      </Helmet>
      <div ref={myRef}>
        <div className="header6">
          <h3>Reports</h3>
          <div className="radio-py">
            <Radio.Group
              value={activeCategory}
              className="report-button"
              onChange={(e) => {
                setActiveCategory(e.target.value);
                getContactHandler(1, e.target.value);
              }}
            >
              <div>
                <Radio.Button value="image_report" className="image-button1">
                  Image Reports
                </Radio.Button>
              </div>
              <div>
                <Radio.Button value="chat_report" className="image-button2">
                  Chat Reports
                </Radio.Button>
              </div>
            </Radio.Group>
          </div>
        </div>
        {/* table */}
        <Table
          columns={columns}
          dataSource={contactData?.data}
          pagination={false}
          loading={loader}
          scroll={{ x: 1023 }}
        />
        {/* modal */}
        <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
          <div className="view_content">
            <h2>{viewData?.name}</h2>
            <h4>Status:-</h4>
            <h6>{viewData?.status}</h6>
            <h4>Attachments :-</h4>
          </div>
          <div
            className="flex"
            style={{ justifyContent: "space-between", marginTop: "10px" }}
          >
            {viewData?.attachments?.map((item, index) => (
              <div>
                <Image
                  key={index}
                  width={130}
                  height={130}
                  src="error"
                  fallback={
                    item?.path !== ""
                      ? item?.path
                      : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                  }
                />
              </div>
            ))}
          </div>
        </Modal>
        {/* Pagination */}
        <Pagination
          defaultPageSize={currentPage}
          showSizeChanger={false}
          current={currentPage}
          pageSize={
            contactData !== undefined && contactData?.length !== 0
              ? contactData?.per_page
              : 1
          }
          total={contactData?.total}
          onChange={(e) => {
            setCurrentPage(e);
            getContactHandler(e, activeCategory);
            executeScroll();
          }}
          className="pagination"
        />
      </div>
    </React.Fragment>
  );
};
export default Reports;
